$(document).ready(function () {
    if ($('.lecture').length > 0) {
        var now = Date.now() / 1000;

        $('#upcoming-lectures-today .lecture').filter(function () {
            var start = $(this).data('start');
            var end = $(this).data('end');
            return start > now;
        }).first().find('.description').collapse('show');
    }
    $('.toggle-days').click(function () {
        var self = $(this);
        if ($(self).data('day') === 'tomorrow') {
            $('#upcoming-lectures-tomorrow').addClass('hide');
            $('#upcoming-lectures-today').removeClass('hide');
        } else {
            $('#upcoming-lectures-tomorrow').removeClass('hide');
            $('#upcoming-lectures-today').addClass('hide');
        }
    });
});
